import axiosInstance from 'api/axiosInstance';
import { stringify } from 'query-string';
import type { FilterResponse } from 'types/global.types';
import type { Quote, QuoteStatus } from 'types/invoice.types';
import type { Paging } from 'types/pagination.types';

const service = '/v2/quotes';

export function getQuotes(params: {
  page: number;
  perPage: number;
  categoryIds?: string[];
}): Promise<{
  data: Quote[];
  paging: Paging;
}> {
  return axiosInstance.get(
    `${service}?${stringify(params, {
      skipEmptyString: true,
      arrayFormat: 'comma',
    })}`,
  );
}

export function getQuotesFilter(): Promise<FilterResponse[]> {
  return axiosInstance.get(`${service}/filters`);
}

export const bulkDeleteQuotes = (ids: string[]): Promise<any> =>
  axiosInstance.delete(
    `${service}/bulk?${stringify(
      { ids },
      { arrayFormat: 'comma', skipEmptyString: true },
    )}`,
  );

export const getQuoteById = (id: string): Promise<Quote> =>
  axiosInstance.get(`${service}/${id}`);

export const changeQuoteStatus = (
  id: string,
  status: QuoteStatus,
): Promise<Quote> =>
  axiosInstance
    .post(`${service}/${id}/status`, { status })
    .then((res) => res.data);

export const deleteQuote = (id: string): Promise<void> =>
  axiosInstance.delete(`${service}/${id}`);

export const hasQuotes = (): Promise<boolean> => {
  return getQuotes({ page: 1, perPage: 1 }).then(
    ({ paging }) => paging.totalCount > 0,
  );
};

type EmailData = {
  to: string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  htmlTemplate: string;
  saveTemplate?: boolean;
  enableTracking?: boolean;
};
export const sendQuoteEmail = (quoteId: string, data: EmailData) =>
  axiosInstance.post(`${service}/${quoteId}/email`, data);
